import { HttpErrorResponse } from '@angular/common/http';

const PUBLIC_AUTH_PATHS = [
  '/v1/super-admin/auth/login',
  '/v1/super-admin/auth/forgot-password',
  '/v1/super-admin/auth/validate-reset-token',
  '/v1/super-admin/auth/reset-password',
] as const;

export function isPublicAuthRequest(url: string): boolean {
  return PUBLIC_AUTH_PATHS.some((path) => url.includes(path));
}

export function isUnauthorizedHttpError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 401;
}
